import {useTranslation} from 'react-i18next'
import {KTSVG} from '../../../../../_metronic/helpers'
import {memo} from 'react'
import {useRoleUser} from '../../../../../hooks/useRoleUser'
import {ActionIcon, PopoverText} from 'src/components'

interface IData {
  id: number
  type: string
  sales_org_code: string
  sector_id: number
  url_file: string
  created_at?: string
  updated_at?: string
}

export interface RowDataProps {
  rowNumber: number
  data: IData
  types: any[]
  isLoadingEditButton: boolean
  onEdit: (data: IData) => void
  onDelete: (data: IData) => void
}

export const RowData = memo((props: RowDataProps) => {
  const {isLoadingEditButton, rowNumber, data, onEdit, onDelete} = props
  const {t} = useTranslation()
  const roleUser = useRoleUser()

  const getType = (type: string) => {
    const found = props.types.find((item: any) => item.value == type)
    return found?.label || type
  }

  return (
    <tr>
      <td>{rowNumber}</td>
      <td>{ getType(data.type) }</td>
      <td>{ data.sales_org_code }</td>
      <td>
        <a rel="noreferrer" className='fw-bold cursor-pointer hover-underline' target='_blank' href={data.url_file}>{ t('file') }</a>
      </td>
      <td>
        <ActionIcon
          className='me-2'
          title={t('Edit')}
          iconPath='/media/icons/duotune/pencil-fill.svg'
          isLoading={isLoadingEditButton}
          disabled={isLoadingEditButton}
          onClick={() => onEdit(data)}
        />
        {/* <button
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
          title={t('Hapus')}
          onClick={() => onDelete(data)}
        >
          <KTSVG path='/media/icons/duotune/trash-fill.svg' className='svg-icon-3' />
        </button> */}
      </td>
    </tr>
  )
})
